import { default as ReactSortable } from 'react-sortablejs';
import { column, handle, header, item, section, sectionEmpty, sectionTitle, staticColumn, staticDivider, staticGroup, staticItem, staticSortable, } from '../styles';
import { column as columnCitrus2022, handle as handleCitrus2022, header as headerCitrus2022, item as itemCitrus2022, section as sectionCitrus2022, sectionEmpty as sectionEmptyCitrus2022, sectionTitle as sectionTitleCitrus2022, staticColumn as staticColumnCitrus2022, staticDivider as staticDividerCitrus2022, staticGroup as staticGroupCitrus2022, staticItem as staticItemCitrus2022, staticSortable as staticSortableCitrus2022, } from '../styles/citrus2022';
import { citrusStyled } from '@citrus/runtime';
export var Handle = citrusStyled.div('handle', { legacy: handle, citrus2022: handleCitrus2022 }, { classNames: ['pcty-sortable-handle'] });
export var Item = citrusStyled.div('item', { legacy: item, citrus2022: itemCitrus2022 }, { classNames: ['pcty-sortable-item'] });
export var Column = citrusStyled.div('column', { legacy: column, citrus2022: columnCitrus2022 }, { classNames: ['pcty-sortable-column'] });
export var Header = citrusStyled.div('header', { legacy: header, citrus2022: headerCitrus2022 }, { classNames: ['pcty-sortable-item'] });
export var SectionTitle = citrusStyled.div('sectionTitle', { legacy: sectionTitle, citrus2022: sectionTitleCitrus2022 }, {
    classNames: ['pcty-sortable-item', 'pcty-sortable-section-title'],
});
export var SectionEmpty = citrusStyled.as(ReactSortable)('sectionEmpty', { legacy: sectionEmpty, citrus2022: sectionEmptyCitrus2022 }, {
    classNames: ['pcty-sortable-section-empty'],
});
export var Section = citrusStyled.as(ReactSortable)('section', { legacy: section, citrus2022: sectionCitrus2022 }, { classNames: ['pcty-sortable-section'] });
export var SectionDiv = citrusStyled.div('section', { legacy: section, citrus2022: sectionCitrus2022 }, { classNames: ['pcty-sortable-section'] });
export var StaticSortable = citrusStyled.table('staticSortable', { legacy: staticSortable, citrus2022: staticSortableCitrus2022 }, {
    classNames: ['pcty-border-top-none'],
});
export var StaticGroup = citrusStyled.tbody('staticGroup', {
    legacy: staticGroup,
    citrus2022: staticGroupCitrus2022,
});
export var StaticItem = citrusStyled.tr('staticItem', { legacy: staticItem, citrus2022: staticItemCitrus2022 });
export var StaticDivider = citrusStyled.tr('staticDivider', {
    legacy: staticDivider,
    citrus2022: staticDividerCitrus2022,
});
export var StaticColumn = citrusStyled.td('staticColumn', { legacy: staticColumn, citrus2022: staticColumnCitrus2022 }, { classNames: ['pcty-list-column'] });
export var Styled = {
    Handle: Handle,
    Item: Item,
    Column: Column,
    Header: Header,
    SectionTitle: SectionTitle,
    SectionEmpty: SectionEmpty,
    Section: Section,
    SectionDiv: SectionDiv,
    StaticSortable: StaticSortable,
    StaticGroup: StaticGroup,
    StaticItem: StaticItem,
    StaticDivider: StaticDivider,
    StaticColumn: StaticColumn,
};
